import { makeStateKey } from '@angular/core';

import { Movie } from '@usheru-hff/shared/domain';

export const MOVIE_TRANSFER_KEY = makeStateKey<Movie>('MOVIE_DATA_KEY');
